<template>
  <el-card
    id="CategoryCard"
    class="clear-card"
    shadow="hover"
    :body-style="{
      height: 'calc(100% - 56px)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    }"
  >
    <div
      slot="header"
      class="header defaultCursor"
    >
      <span>
        {{ $t('coach.leader.category.title') }}
      </span>
    </div>

    <div
      class="content"
      :class="{'noData': tier !== 0 && !tier}"
    >
      <span
        v-if="tier !== 0 && !tier"
        class="noCategory"
      >
        {{ $t('coach.leader.category.noData') }}
      </span>
      <div
        v-else
        class="hasCategory"
        :class="['mobile', 'tablet']
          .includes($mq) ? 'mobileMode' : $mq === 'laptop' ? 'laptopMode' : null"
      >
        <template v-if="formattedCategory">
          {{ formattedCategory }}
        </template>
        <template v-else>
          {{ $t(`coachingTier.tier_${tier}`) }}
          {{ $t(`coachingTier.tier_${tier}_caption`) }}
        </template>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  props: {
    tier: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    formattedCategory() {
      let defaultCategory = null;

      if (process.env.VUE_APP_SERVICE === 'ing_gcg_platform') {
        defaultCategory = this.$t('coachingTier.ingLeaders');
      }

      return defaultCategory;
    },
  },
};
</script>

<style lang="scss" scoped>
#CategoryCard {
  text-align: center;

  .noCategory {
    font-weight: normal;
    color: #c4c4c4;
  }

  .hasCategory {
    font-size: 16px;

    &.mobileMode {
      font-size: 16px;
    }
  }

  .header {
    font-weight: bold;
  }

  .content {
    // font-weight: bold;

    &.noData {
      box-sizing: border-box;
      color: #c4c4c4;
    }
  }
}
</style>

<style lang="scss">
#CategoryCard {
  .el-card__body {
    height: 100%;
    box-sizing: border-box;
  }
}
</style>
